export default {
  CSV: 'csv',
  PNG: 'png',
  JPEG: 'jpeg',
  ALLCSV: 'allcsv',
};
